import * as types from 'store/mutation-types'
import { SEC_TYPE } from 'const/stock'
import Stock from 'utils/stock'
import Option from 'utils/option'
import isNeedRefresh from 'utils/isNeedRefresh'
import { fetchStockCorActionList } from 'apis/stock'
import isSameStock from 'utils/isSameStock'

const HISTORY_COUNT = 20
const state = {
  hasNew: false,
  symbols: [], // 用来本地存储的股票代码 {symbol, secType, expiry, strike, right}
  list: []
}

const mutations = {
  [types.ADD_HISTORY_STOCK](state, stock) {
    const list = state.symbols.concat([])
    const stockExisted = list.findIndex(each => {
      if (stock.symbol !== each.symbol || stock.secType !== each.secType) {
        return false
      }
      if (stock.secType === SEC_TYPE.OPT) {
        return (
          stock.expiry === each.expiry &&
          stock.strike === each.strike &&
          stock.right === each.right
        )
      }
      return true
    })
    if (stockExisted >= 0) {
      state.hasNew = false
      list.splice(stockExisted, 1)
    } else {
      state.hasNew = true
    }
    list.unshift(stock)
    state.symbols = list.slice(0, HISTORY_COUNT)
  },
  [types.UPDATE_HISTORY_STOCK](state, list) {
    list.forEach(data => {
      const existedStockIdx = state.list.findIndex(stock =>
        isSameStock(stock, data)
      )
      const existedStock = state.list[existedStockIdx]
      if (existedStock) {
        Object.assign(existedStock, data)
      }
    })
  },
  [types.INIT_HISTORY_LIST](state, list) {
    state.list = list
  },
  [types.CLEAR_HISTORY_LIST](state) {
    state.list = []
    state.symbols = []
  }
}
const getters = {
  historyList(state) {
    return state.list
  },
  historyListSymbols(state) {
    return state.symbols
  }
}

async function loadStockWithOpts(symbols) {
  const list = []
  const stocks = symbols
    .filter(stock => stock.secType !== SEC_TYPE.OPT)
    .map(stock => ({ symbol: stock.symbol }))
  const opts = symbols.filter(opt => opt.secType === SEC_TYPE.OPT)
  if (stocks.length > 0) {
    const stockBriefs = await Stock.getAllStockBriefs({
      lite: false,
      hkDelay: this.hkDelay,
      items: stocks
    })
    stockBriefs.forEach(info => {
      const index = symbols.findIndex(sym => {
        return info.symbol === sym.symbol && sym.secType !== SEC_TYPE.OPT
      })
      if (index > -1) {
        list[index] = info
      }
    })
  }
  if (opts.length > 0) {
    const items = opts.map(opt => {
      return {
        symbol: opt.symbol,
        expiry: opt.expiry,
        strike: opt.strike,
        right: opt.right
      }
    })
    const optionBriefs = await Option.getAllOptionDetails(items)
    if (!optionBriefs) {
      return stocks.filter(stock => stock.secType !== SEC_TYPE.OPT)
    }
    optionBriefs.forEach(item => {
      const index = symbols.findIndex(stock => {
        if (stock.secType === SEC_TYPE.OPT) {
          return (
            stock.symbol === item.symbol &&
            stock.expiry === item.expiry &&
            stock.right.toLowerCase() === item.right.toLowerCase() &&
            stock.strike === item.strike
          )
        }
      })
      if (index > -1) {
        list[index] = item
      }
    })
  }
  return list.filter(Boolean)
}

const actions = {
  addStockToHistoryList({ commit }, stock) {
    commit(types.ADD_HISTORY_STOCK, stock)
  },
  initHistoryList({ commit, dispatch, state }) {
    return loadStockWithOpts(state.symbols)
      .then(stocks => {
        return dispatch('updateHistoryCorAction', stocks)
      })
      .then(stocks => {
        commit(types.INIT_HISTORY_LIST, stocks)
      })
  },
  updateHistoryCorAction({ commit }, stocks) {
    const symbols = stocks
      .map(st => {
        if (st.secType === SEC_TYPE.OPT) return
        return st.symbol
      })
      .filter(Boolean)
    return fetchStockCorActionList(symbols)
      .then(corporates => {
        (corporates || []).forEach(item => {
          const target = stocks.find(stock => {
            return stock.symbol === item.symbol
          })
          if (target) {
            if (target.corporates) {
              target.corporates.push(item)
            } else {
              target.corporates = [item]
            }
          }
        })
        return stocks
      })
      .catch(() => {
        // FIXME：公司行动获取出错页面不显示，但需要上报或通知监控
        return stocks
      })
  },
  async refreshHistoryList({ state, getters, commit }) {
    const list = await loadStockWithOpts(state.symbols)
    commit(
      types.UPDATE_HISTORY_STOCK,
      list.filter(stock => isNeedRefresh(stock, getters))
    )
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
